
import { mapState } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
import order from "../../mixins/order";
export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false
  },
  mixins: [order],
  data() {
    return {
      progress: 0,
      progressInterval: null
    };
  },
  computed: {
    ...mapState("restaurant", ["businessDetails"]),
    brandId() {
      return this.$route.params.brand;
    },
    locationId() {
      return this.$route.params.location;
    }
  },
  methods: {
    handleNavigateToWhatsappClick() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
      }
      this.progress = 100;
      this.navigateToWhatsappChat();
    },
    startLoader() {
      this.progress = 0;
      this.progressInterval = setInterval(() => {
        this.progress += 1;
        if (this.progress >= 100) {
          clearInterval(this.progressInterval);
          this.$refs.whatsappButton.click();
        }
      }, 50);
    }
  },
  mounted() {
    this.startLoader();
  },
  beforeDestroy() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  }
};
